"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorCode = void 0;
var ErrorCode;
(function (ErrorCode) {
    ErrorCode["CART_LIMITATION_EXCEEDED_UNITS"] = "cart.limitation.exceeded.cart.units";
    ErrorCode["CART_LIMITATION_EXCEEDED_CAMPAIGNS"] = "cart.limitation.exceeded.cart.campaigns";
    ErrorCode["CART_LIMITATION_EXCEEDED_ITEM_UNITS"] = "cart.limitation.exceeded.item.units";
    ErrorCode["CART_BRANDSPLACE_LIMITATION_EXCEEDED"] = "cart.brandsplace.limitation.exceeded";
    ErrorCode["INVALID_ITEM_ID"] = "invalid.item.id";
    ErrorCode["INVALID_ITEM_QUANTITY"] = "invalid.item.quantity";
    ErrorCode["CATALOG_ERROR"] = "catalog.error";
    ErrorCode["RESERVATION_ERROR"] = "reservation.error";
    ErrorCode["CATALOG_ITEM_NOT_FOUND"] = "catalog.item.not.found.error";
    ErrorCode["RESERVATION_NOT_ENOUGH_STOCK_ERROR"] = "reservation.not.enough.stock.error";
    ErrorCode["CART_SAVE_ERROR"] = "cart.save.error";
    ErrorCode["CART_ITEM_RETRIEVAL_ERROR"] = "cart.item.retrieval.error";
    ErrorCode["CART_MAX_UNIT_PER_MEMBER"] = "cart.limitation.exceeded.max.per.member";
    ErrorCode["UNAUTHORIZED"] = "Unauthorized";
    ErrorCode["LOYALTY_RENEWAL"] = "cart.loyalty.renewal.not.permitted";
    ErrorCode["CART_RULE_VBI_THIRD_PARTY"] = "cart.rule.vbi.third.party.error";
    ErrorCode["CART_RULE_NON_VBI_THIRD_PARTY"] = "cart.rule.non.vbi.third.party.error";
    ErrorCode["RESERVATION_OVERFLOW_ERROR"] = "reservation.overflow.error";
    ErrorCode["CART_LIMITATION_EXCEEDED_CART_REOPEN_CAMPAIGNS"] = "cart.limitation.exceeded.cart.reopen.campaigns";
    ErrorCode["CART_RULE_FLASH_THIRD_PARTY"] = "cart.rule.flash.third.party.error";
    ErrorCode["CART_NATURE"] = "cart.nature.error";
})(ErrorCode || (exports.ErrorCode = ErrorCode = {}));
